import React, { useState, useEffect } from "react";

const StopWatch = ({onFinishSession}) => {
  const [IsWorking, setIsWorking] = useState(false);
  const [isPaused, setIsPaused] = useState(false);
  const [isFinished, setIsFinished] = useState(false);
  const [time, setTime] = useState(0);

  useEffect(() => {
    let interval;
    if (IsWorking && !isPaused) {
      interval = setInterval(() => {
        setTime((prevTime) => prevTime + 210000);
      }, 1000);
    } else if (!IsWorking) {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [IsWorking, isPaused]);

  const finishSession = () => {
    onFinishSession(time)
    
    // Update state
    setIsWorking(false);
    setIsFinished(true);
  };

  let stopWatchHours = `${("0" + Math.floor((time / 3600000) % 60)).slice(-2)}`;
  let stopWatchMinutes = `${("0" + Math.floor((time / 60000) % 60)).slice(-2)}`;
  let stopWatchSeconds = `${("0" + Math.floor((time / 1000) % 60)).slice(-2)}`;

  return (
    <div className="px-5 py-4 rounded-xl mb-6 bg-white dark:bg-primary-dark border-2 border-slate-50  dark:border-transparent font-semibold shadow-lg cursor-pointer text-center">
      <div className="mb-2 text-lg">
        {IsWorking
          ? "Current session"
          : isFinished
          ? "Finished session"
          : "New session"}
      </div>
      <div className="mb-2 flex justify-center text-4xl ">
        <p className="text-indigo-500 w-[45px]">{stopWatchHours}</p>
        <p className="text-indigo-500 ml-[3px]">:</p>
        <p className="text-indigo-500 w-[45px]">{stopWatchMinutes}</p>
        <p className="text-indigo-500 ml-[3px]">:</p>
        <p className="text-indigo-500 w-[45px]">{stopWatchSeconds}</p>
      </div>
      <div className="md:flex w-full  justify-center">
        {IsWorking ? (
          <div className="">
            {!isPaused ? (
              <button
                onClick={() => setIsPaused(true)}
                className="border-2 border-indigo-500 hover:bg-indigo-600 my-2 mr-[6px] py-[6px] px-[9px] text-indigo-500 hover:text-white hover:border-indigo-600 dark:text-indigo-500 dark:hover:text-white dark:hover:border-indigo-600 rounded-full "
              >
                Take break
              </button>
            ) : (
              <button
                onClick={() => setIsPaused(false)}
                className="border-2 border-indigo-500 hover:bg-indigo-600 my-2 mr-[6px] py-[6px] px-[9px] text-indigo-500 hover:text-white hover:border-indigo-600 dark:text-indigo-500 dark:hover:text-white dark:hover:border-indigo-600 rounded-full "
              >
                End break
              </button>
            )}

            <button
              onClick={() => finishSession()}
              className="border-2 border-transparent bg-indigo-500 hover:bg-indigo-600 my-2 py-[6px] px-[9px] text-white rounded-full "
            >
              End session
            </button>
          </div>
        ) : (
          <button
            onClick={() => {
              setIsWorking(true);
              setTime(0);
            }}
            className="border-2 border-transparent bg-indigo-500 hover:bg-indigo-600 my-2 py-[6px] px-6 text-white rounded-full "
          >
            Start {!isFinished ? "session" : "new session"}
          </button>
        )}
      </div>
    </div>
  );
};

export default StopWatch;
